module.exports = __webpack_public_path__ + "static/media/feature-manage1.04e4d378.png";